import { createAction, props } from '@ngrx/store'
import { CompanySettingPreferencesAPIModel } from '../../models/api.model'

const actionSettingsPrefix = '[settings]'

export const fetch_company_setting_preferences_data = createAction(
  `${actionSettingsPrefix} fetch_company_setting_preferences_data`,
  props<{ referenceId: string; referenceType: string }>()
)

export const fetch_company_setting_preferences_data_success = createAction(
  `${actionSettingsPrefix} fetch_company_setting_preferences_data_success`,
  props<{ companySettingPreferences: CompanySettingPreferencesAPIModel }>()
)

export const update_settings_action = createAction(
  `${actionSettingsPrefix} update_settings_action`,
  props<{
    referenceId: string
    referenceType: string
    settingsType: string
    companySettingPreferences: CompanySettingPreferencesAPIModel
  }>()
)

export const update_settings_success_action = createAction(
  `${actionSettingsPrefix} update_settings_success_action`,
  props<{ companySettingPreferences: CompanySettingPreferencesAPIModel }>()
)
